module.exports = __webpack_public_path__ + "static/media/mafalda_silva.508534ae.jpg";